import axios from 'axios';
import Config from '../../config';
import { toast } from 'react-toastify';
import { MODAL_CLOSE } from '../actions';
import {
    CREATE_PROPERTY_MASTER_FAILURE,
    CREATE_PROPERTY_MASTER_REQUEST,
    CREATE_PROPERTY_MASTER_SUCCESS,
    CREATE_USER_FORM_PROPERTY_MASTER,
    DELETE_PROPERTY_MASTER_FAILURE,
    DELETE_PROPERTY_MASTER_REQUEST,
    DELETE_PROPERTY_MASTER_SUCCESS,
    FETCH_IPADDRESS_FAILURE,
    FETCH_IPADDRESS_REQUEST,
    FETCH_IPADDRESS_SUCCESS,
    FETCH_PROPERTY_MASTER_FAILURE,
    FETCH_PROPERTY_MASTER_REQUEST,
    FETCH_PROPERTY_MASTER_SUCCESS,
    FETCH_SINGLE_PROPERTY_MASTER_FAILURE,
    FETCH_SINGLE_PROPERTY_MASTER_REQUEST,
    FETCH_SINGLE_PROPERTY_MASTER_SUCCESS,
    PROPERTY_MASTER_SET_ACTIVE_FAILURE,
    PROPERTY_MASTER_SET_ACTIVE_REQUEST,
    PROPERTY_MASTER_SET_ACTIVE_SUCCESS,
    PROPERTY_MASTER_USERFORM_RESET,
    UPDATE_PROPERTY_MASTER_FAILURE,
    UPDATE_PROPERTY_MASTER_REQUEST,
    UPDATE_PROPERTY_MASTER_SUCCESS
} from './propertyMaster.actionsType';
import axiosCall from '../axiosCall';
import ConstantApi from '../../ConstantApi';
import { fetchProperty } from '../property/property.actions';

//Fetch Ip address
export let getIpAddress = () => {
    return (dispatch) => {
        dispatch({ type: FETCH_IPADDRESS_REQUEST });
        var config = {
            method: 'get',
            url: `https://geolocation-db.com/json/50ad4a90-fd5e-11ec-b463-1717be8c9ff1`
        };
        axios(config)
            .then((response) => {
                // console.log('response', JSON.stringify(response.data));
                dispatch({ type: FETCH_IPADDRESS_SUCCESS, payload: response.data });
            })
            .catch((error) => {
                // console.log('error :>> ', error.response);
                dispatch({ type: FETCH_IPADDRESS_FAILURE, payload: error });
            });
    };
};

// FETCH PROPERTY MASTER
export let fetchPropertyMaster = () => {
    let config = {
        method: 'get',
        url: ConstantApi.propertyMasterGET,
        responseTypeRequest: FETCH_PROPERTY_MASTER_REQUEST,
        responseTypeSuccess: FETCH_PROPERTY_MASTER_SUCCESS,
        responseTypeFailure: FETCH_PROPERTY_MASTER_FAILURE
    };
    return axiosCall(config);
};

export let createPropertyMasterUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_PROPERTY_MASTER, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createMasterProperty = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        fldSlNo: parseInt(formData.slno),
        fldDescription: formData.description,
        fldShortName: formData.sdescription,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString()
        // fldModifiedBy: 1,
        // fldModifiedDt: '2022-04-22T00:00:00',
        // fldDeletedBy: 1,
        // fldDeletedDt: '2022-04-22T00:00:00'
    });

    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.propertyMasterPOST}`,
        responseTypeRequest: CREATE_PROPERTY_MASTER_REQUEST,
        responseTypeSuccess: CREATE_PROPERTY_MASTER_SUCCESS,
        responseTypeFailure: CREATE_PROPERTY_MASTER_FAILURE,
        resetFormData: PROPERTY_MASTER_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchPropertyMaster()
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSinglePropertyMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.propertyMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_PROPERTY_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_PROPERTY_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_PROPERTY_MASTER_FAILURE,
        singlApiArray: [fetchPropertyMaster()]
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let toggleSetActive = (id) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.propertyMasterGET_SET_ACTIVE}/${id}`,
        responseTypeRequest: PROPERTY_MASTER_SET_ACTIVE_REQUEST,
        responseTypeSuccess: PROPERTY_MASTER_SET_ACTIVE_SUCCESS,
        responseTypeFailure: PROPERTY_MASTER_SET_ACTIVE_FAILURE,
        getAllData: fetchProperty()
    };
    return axiosCall(config);
};


//UPDATE PROPERTY MASTER
export let updateMasterProperty = (id, formData) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldSlNo: parseInt(formData.slno),
        fldDescription: formData.description,
        fldShortName: formData.sdescription,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: formData.fldModifiedBy,
        fldModifiedDt: today.toISOString()
        // fldDeletedBy: formData.fldDeletedBy,
        // fldDeletedDt: formData.fldDeletedDt
    });

    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.propertyMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_PROPERTY_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_PROPERTY_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_PROPERTY_MASTER_FAILURE,
        resetFormData: PROPERTY_MASTER_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchPropertyMaster()
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deletePropertyMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.propertyMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_PROPERTY_MASTER_REQUEST,
        responseTypeSuccess: DELETE_PROPERTY_MASTER_SUCCESS,
        responseTypeFailure: DELETE_PROPERTY_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchPropertyMaster()
    };
    return axiosCall(config);
};
